import { dateFormat } from '@/utils/dateFormat';

const commonFormatter = (v) => {
  if (!v && v !== 0) {
    return '--';
  }
  return v;
};

function setExpandTbCols () {
  let commonCols = [
    {
      tooltip: true,
      title: '供应商名称',
      field: 'supplierName',
      showOverflow: true,
      minWidth: '150px',
      align: 'left',
    },
    {
      title: '报价金额',
      field: 'totalAmount',
      align: 'left',
      slots: {
        default: ({ row }, h) => {
          let result = [];
          result = [
            h('b', { class: '' }, row.totalAmount),
          ];
          return [h('div', result)];
        },
      },
    },
    {
      title: '税率',
      field: 'taxRate',
      align: 'left',
      formatter: ({ cellValue }) => {
        return cellValue !== null ? `${(Number(cellValue) * 100).toFixed(0)}%` : '';
      },
    },
    {
      title: '无税金额',
      sortable: true,
      field: 'notTaxTotalAmount',
      align: 'left',
    },
    {
      title: '交期',
      field: 'plannedDeliveryDate',
      align: 'left',
      formatter: ({ cellValue }) => {
        return cellValue ? dateFormat(cellValue).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '联系人',
      field: 'contactName',
      align: 'left',
    },
    {
      title: '联系电话',
      field: 'contactPhone',
      align: 'left',
    },
    {
      title: '报价状态',
      field: 'status',
      align: 'left',
      slots: {
        default: ({ row }, h) => {
          let result = [];
          let statusDesc = '';
          const statusEnum = ['CLOSED', 'NEGOTIATING'];
          if (!statusEnum.includes(row.status)) {
            statusDesc = `供应商${row.statusDesc}`;
          } else {
            statusDesc = row.statusDesc;
          }
          result.push(
            h('span', statusDesc || '--'),
          );
          // 已回退 加提示
          if (row.status === 'CANCELED' && row.rollbackReason) {
            result.push(
              h(
                'el-tooltip',
                {
                  props: {
                    effect: 'dark',
                    content: row.rollbackReason,
                    placement: 'bottom-start',
                  },
                },
                [
                  h('i', {
                    class: 'el-icon-info',
                    style: 'color:#F56C6C; margin-left:5px;font-size: 14px;',
                  }),
                ],
              ),
            );
          }
          return h('div', result);
        },
      },
    },
  ];

  return commonCols;
}
// 订单列表配置
export function setOrderTableColumns (type = 0) {
  const orderTableColumns = [
    {
      type: 'expand',
      width: '50px',
      fixed: 'left',
      slots: {
        header: (_, h) => {
          let className = this.isExpand !== 3 ? 'allExpandIcon vxe-icon-arrow-down' : 'vxe-icon-arrow-right';
          let name = this.isExpand !== 3 ? 'vxe-icon-arrow-down' : 'vxe-icon-arrow-right';
          return [h('div', [<i name={name} class={className} style='cursor: pointer;font-size: 16px;' onClick={() => this.handleToggleExpand()}></i>])];
        },
        content: ({ row }, h) => {
          if (row.supplierQuotePriceList?.length) {
            return [
              h('vxe-grid', {
                style: {
                  'z-index': 10,
                  'margin-left': '50px',
                  'margin-right': '100px',
                  'margin-top': '10px',
                  'margin-bottom': '10px',
                },
                props: {
                  align: 'center',
                  resizable: true,
                  stripe: false,
                  border: true,
                  autoResize: true,
                  showHeader: true,
                  showOverflow: true,
                  maxHeight: '500px',
                  size: 'mini',
                  data: row.supplierQuotePriceList || [],
                  columns: setExpandTbCols(type, row, this),
                },
              }),
            ];
          }
        },
      },
    },
    {
      tooltip: true,
      title: '询价描述',
      field: 'inquireDesc',
      showOverflow: true,
      width: '200px',
      align: 'left',
    },
    {
      title: '业务类型',
      field: 'businessTypeDesc',
      showOverflow: false,
      align: 'left',
    },
    {
      title: '接单状态',
      field: 'taskOrderStatusDesc',
      showOverflow: false,
      align: 'left',
      slots: {
        default: ({ row }, h) => {
          return [h('div', `供应商${row.taskOrderStatusDesc}`)];
        },
      },
    },
    {
      title: '报价状态',
      field: 'quotePriceStatusDesc',
      showOverflow: false,
      align: 'left',
      slots: {
        default: ({ row }, h) => {
          return [h('div', `供应商${row.quotePriceStatusDesc}`)];
        },
      },
    },
    {
      title: '询单单号',
      field: 'code',
      showOverflow: false,
      align: 'left',
      slots: {
        default: ({ row }, h) => {
          let result = [];
          result = [
            h('span', {
              class: 'table-action',
              on: {
                click: () => {
                  this.handleShowDetail(row);
                },
              },
            }, row.code),
          ];
          return [h('div', result)];
        },
      },
    },
    {
      title: '单据状态',
      field: 'statusDesc',
      showOverflow: false,
      align: 'left',
    },
    {
      title: '询单来源',
      field: 'inquireSourceDesc',
      showOverflow: false,
      align: 'left',
    },
    {
      tooltip: true,
      title: '终端用户',
      field: 'terminalCustomer',
      showOverflow: true,
      align: 'left',
    },
    {
      tooltip: true,
      title: '询价单位/个人',
      field: 'inquirePriceParty',
      showOverflow: true,
      align: 'left',
    },
    {
      title: '创建人',
      field: 'createUserName',
      showOverflow: false,
      align: 'left',
    },
    {
      title: '创建时间',
      field: 'createTime',
      showOverflow: false,
      align: 'left',
      formatter: ({ cellValue }) => {
        return cellValue ? dateFormat(cellValue).format('YYYY-MM-DD HH:mm:ss') : '--';
      },
    },
    {
      title: '紧急程度',
      field: 'emergencyLevel',
      slots: {
        default: ({ row }, h) => {
          let emergencyLevelName = {
            LOW: '低',
            MEDIUM: '中',
            HIGH: '高',
          }[row.emergencyLevel];
          return [h('div', row.emergencyLevel === 'HIGH' ? [
            <span style='color:red;font-weight:600;'>{ emergencyLevelName || ''}</span>,
          ] : [
            <span>{ emergencyLevelName || ''}</span>,
          ])];
        },
      },
    },
    {
      title: '操作',
      fixed: 'right',
      showOverflow: false,
      width: '80px',
      slots: {
        default: ({ row }, h) => {
          let actions = [];
          // let queryStatus = this.$store.state.auth.actionPermissionMap['purchase_mall:inquiryList:deal'] || false;
          if (row.status !== 'FINISHED') { // && queryStatus
            actions.push(
              <span class='table-action' v-auth={'saas_gongxutong:inquire_price:close'} onClick={() => this.handleClose(row)}>关单</span>,
            );
          }
          return [h('div', actions)];
        },
      },
    },
  ];

  orderTableColumns.forEach(v => {
    v.headerAlign = 'left';
    v.align = 'left';

    if (!v.formatter) {
      v.formatter = ({row}) => {
        return commonFormatter(row[v.field]);
      };
    }
  });

  return orderTableColumns;
}
